// Company stamp on Sales PDFs (Stage 2E-5): drawn beside the signature line, in the existing signature / stamp area, so
// nothing in the layout moves. The image keeps its own aspect ratio and transparency (PNG alpha); it is never stretched.
// Callers pass null for documents that must not carry the stamp (drafts) — then nothing is drawn and the PDF is unchanged.
export const STAMP_MM = 24;   // the stamp's larger side

/**
 * @param {object} doc      jsPDF document
 * @param {{data: Uint8Array|string, format: "PNG"|"JPEG", w: number, h: number}|null} stamp
 * @param {number} xs       left edge of the signature column (the stamp sits 4 mm to its left)
 * @param {number} lineY    y of the signature line (the stamp is centred 2 mm above it)
 */
export function drawStamp(doc, stamp, xs, lineY) {
    if (!stamp) return;
    const s = Math.min(STAMP_MM / stamp.w, STAMP_MM / stamp.h), w = stamp.w * s, h = stamp.h * s;
    doc.addImage(stamp.data, stamp.format, xs - 4 - w, lineY - 2 - h / 2, w, h, "stamp", "FAST");
}
